<div
  animate.enter="animate-up"
  animate.leave="animate-down"
  class="w-[30vw] min-h-screen flex items-center justify-center"
>
  <div class="relative w-full">
    <div class="top-0 left-0 absolute">
      <!--      <button class="bg-primary w-12 h-12 text-white rounded-full">-->
      <!--        dd-->
      <!--      </button>-->

      <!-- <button (click)="goBack()" class="bg-gray-100 p-0.5 text-gray rounded-xl">
        <div class="py-1.5 pl-2.5 pr-3 bg-white hover:bg-gray-100/50 rounded-xl flex items-center gap-1.5">
          <mat-icon svgIcon="back"></mat-icon>
          {{ 'Back' | concat | translate }}
        </div>
      </button> -->
    </div>
    <div
      class=" w-full min-h-screen rounded-xl flex flex-col items-center justify-center"
    >
      <img src="assets/images/emblem.png" class="w-20" alt="" />
      <span class="text-black text-xl text-center font-bold mt-5 mb-2">{{
        "Forgot Your Password?" | concat | translate
      }}</span>
      <p class="text-gray-dark text-center">
        {{ "forgot password instructions" | concat | translate }}
      </p>
      <form
        (ngSubmit)="submitForm(form.value)"
        [formGroup]="form"
        autocomplete="off"
        novalidate
        class="w-full mt-3"
      >
        <mat-form-field appearance="outline">
          <mat-label>{{ "Email Address" | concat | translate }}</mat-label>
          <input type="email" matInput formControlName="email" />
          <mat-icon matIconSuffix>email</mat-icon>
          <mat-error>
            <span
              *ngIf="!form.get('email')?.valid && form.get('email')?.touched"
            >
              {{ "Field is required" | concat | translate }}
            </span>
          </mat-error>
        </mat-form-field>

        <div class="w-full mb-3">
          <button
            type="submit"
            [disabled]="!form.valid || loading"
            class="w-full"
            mat-raised-button
            color="primary"
          >
            {{ "Reset Password" | concat | translate }}
          </button>
        </div>
          <div class="w-full mt-4 text-right">
           <p class="text-md text-gray-dark"><a href="#" class="text-primary font-bold">{{ 'Back To Log In' | concat | translate }}</a></p>
            </div>
      </form>
    </div>
  </div>
</div>
